<template>
    <div class="rfq" >
<!--        <el-card >-->
<!--            <el-breadcrumb separator="/">-->
<!--                &lt;!&ndash; <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item> &ndash;&gt;-->
<!--                <el-breadcrumb-item>客户端商品采购</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>客户端订单</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="订单编号">
                        <el-input v-model="searchForm.orderNo" placeholder="订单编号" size="mini" :disabled="loading" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="用户邮箱">
                        <el-input v-model="searchForm.email" placeholder="用户邮箱" size="mini" :disabled="loading" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="收货人">
                        <el-input v-model="searchForm.consignee" placeholder="收货人" size="mini" :disabled="loading" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="收货人手机">
                        <el-input v-model="searchForm.mobile" placeholder="收货人手机" size="mini" :disabled="loading" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="收货地址">
                        <el-input v-model="searchForm.address" placeholder="收货地址" size="mini" :disabled="loading" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="下单日期">
                        <el-date-picker size="mini" v-model="searchForm.timeDate" type="daterange" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"  clearable>
                        </el-date-picker>
                    </el-form-item>
<!--                    <el-form-item label="订单编号">-->
<!--                        <el-input v-model="searchForm.orderBatch" placeholder="订单编号" size="mini" clearable></el-input>-->
<!--                    </el-form-item>-->
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="状态" size="mini" :disabled="loading" multiple>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="待下单" value="0"></el-option>
                            <el-option label="已下单" value="2"></el-option>
                            <el-option label="已发货" value="3"></el-option>
                            <el-option label="已取消" value="5"></el-option>
                            <el-option label="已驳回" value="6"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini" :loading="loading">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table
                    stripe
                    ref="dataTable"
                    :data="tableData"
                    size="mini"
                    v-loading="loading"
                    @selection-change="handleSelectionChange"
                    :height="tableConfig.height"
                    style="width: 100%">
                    <el-table-column type="selection" width="55" :selectable="canSelect" fixed/>
                    <el-table-column
                        prop="orderNo"
                        label="订单编号" width="200" fixed>
                    </el-table-column>
                    <el-table-column
                        prop="email"
                        label="用户邮箱" width="200">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="提报人" width="80">
                    </el-table-column>
                    <el-table-column
                        prop="departmentName"
                        label="所属部门" width="150">
                    </el-table-column>
                    <el-table-column
                        prop="demandMonth"
                        label="需求所属月份" width="150">
                        <template slot-scope="scope">
                            <span>{{ scope.row['demandMonth'] }}<i class="el-icon-edit" style="color:#409eff;margin-left:8px;cursor: pointer;" @click="handleEditDemandMonth(scope.row)"></i></span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="consignee"
                        label="收货人" width="120">
                    </el-table-column>
                    <el-table-column
                        prop="mobile"
                        label="收货人手机" width="120">
                    </el-table-column>
                    <el-table-column
                        prop="address"
                        label="收货地址" width="300">
                    </el-table-column>
                    <el-table-column
                        prop="itemNum"
                        label="商品种类数量" width="150" align="center">
                    </el-table-column>
<!--                    <el-table-column-->
<!--                        prop="orderBatch"-->
<!--                        label="订单编号" width="120">-->
<!--                    </el-table-column>-->
                    <el-table-column
                        prop="totalUntaxedPrice"
                        label="未税总价(元)"
                        width="150"
                        align="center">
                    </el-table-column>
                    <el-table-column
                            prop="totalPrice"
                            label="含税总价(元)"
                            width="150"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="freight"
                            label="运费(元)"
                            width="150"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="total"
                            label="总价(元)"
                            width="150"
                            align="center">
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                            label="创建时间" width="200" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="orderTime"
                        label="下单时间" width="200" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="reason"
                        label="采购原因" width="200" align="center">
                    </el-table-column>
                     <el-table-column
                            fixed="right"
                            prop="status"
                            label="状态"
                            width="100" align="center">
                         <template slot-scope="scope">
                            <el-tag v-if="scope.row.status == 0">待下单</el-tag>
                            <el-tag v-if="scope.row.status == 2">已下单</el-tag>
                            <el-tag v-if="scope.row.status == 3">已发货</el-tag>
                            <el-tag v-if="scope.row.status == 4">已收货</el-tag>
                            <el-tag v-if="scope.row.status == 5">已取消</el-tag>
                            <el-tag v-if="scope.row.status == 6">已驳回</el-tag>
                         </template>
                     </el-table-column>
                    <el-table-column label="操作" width="200" align="right" fixed="right" ref="dataTable">
                        <template slot="header" slot-scope="header">
                            <el-dropdown style="margin-left: 8px;" @command="exportOrderDialogNew">
                                <el-button type="primary" size="mini">
                                    导出<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="all">导出全部</el-dropdown-item>
                                    <el-dropdown-item command="selected">导出已选</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <!-- <el-button type="primary" size="mini" @click="exportOrderDialogNew()" :loading="loading">导出</el-button> -->
<!--                            <el-button type="primary" size="mini" @click="exportDeliver()">导出签收单</el-button>-->
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text"
                                size="mini"
                                @click="handleToReviewDetail(scope.row)">详情</el-button>
                            <el-divider direction="vertical" ></el-divider>
                            <el-button type="text"
                                size="mini"
                                @click="handleToDeliver(scope.row)">签收单</el-button>
                            <el-divider direction="vertical" v-if="scope.row.status == 0&&scope.row.review" ></el-divider>
                            <el-button type="text"
                                    size="mini" v-if="scope.row.status == 0&&scope.row.review"
                                    @click="passIt(scope.row.id,scope.row.reviewStep,scope.row.workflowId,scope.row.consignee,scope.row.totalPrice)"
                                    >通过</el-button>
<!--                           @click="addProcess(scope.row)"-->
                            <el-divider direction="vertical" v-if="scope.row.status == 0&&scope.row.review" ></el-divider>
                            <el-button type="text"
                                    size="mini" v-if="scope.row.status == 0&&scope.row.review"
                                    @click="showReviewDialog(scope.row.id,scope.row.reviewStep,scope.row.workflowId,scope.row.consignee,scope.row.totalPrice)"
                                    >驳回</el-button>

                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>

        <el-dialog title="导出订单" :visible.sync="exportOrderVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="exportOrderForm" :model="exportOrderForm" :rules="rules" label-width="100px">
                <el-form-item label="订单编号" prop="orderBatch">
                    <el-input v-model="exportOrderForm.orderBatch" placeholder="请输入订单编号" size="mini" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="exportOrderVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportOrder">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="" :visible.sync="reviewVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="reviewForm" :model="reviewForm" :rules="rules" label-width="100px">
                <el-form-item label="审核结果" prop="pass"  v-if="false">
                    <el-select v-model="reviewForm.pass" placeholder="" >
                        <el-option label="通过" value="true"></el-option>
                        <el-option label="拒绝" value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="驳回原因" prop="reason" v-if='reviewForm.pass == "false"'>
                    <el-input v-model="reviewForm.reason" placeholder="请输入驳回原因" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="reviewVisible = false">取 消</el-button>
                <el-button type="primary" @click="addProcess()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="查看签收单" :visible.sync="viewDeliverVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="exportOrderForm" :model="exportOrderForm" :rules="rules" label-width="100px">
                <el-form-item label="订单编号" prop="orderBatch">
                    <el-input v-model="exportOrderForm.orderBatch" placeholder="请输入订单编号" size="mini" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="viewDeliverVisible = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="修改需求所属月份" :visible.sync="editDemandMonthVisible" :close-on-click-modal="false" width="500px">
            <el-form ref="editDemandMonthForm" :model="editDemandMonthForm" :rules="rules" label-width="100px">
                <el-form-item label="需求所属月份" prop="demandMonth">
                    <el-select v-model="editDemandMonthForm.demandMonth" placeholder="请选择需求所属月份" >
                        <el-option v-for="demandMonth in demandMonthOption" :key="demandMonth" :label="demandMonth" :value="demandMonth"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDemandMonthVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmitEditDemandMonth">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { downloadByPost, convertRes2Blob } from '../../utils/download.js';
import { KeepAliveTableMixins } from '../../mixin/KeepAliveTable';
const HEIGHT_OFFSET = 118;
export default {
    mixins: [KeepAliveTableMixins],

    data() {
        return {
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            reviewVisible:false,
            searchForm: {
                orderNo: "",
                email: "",
                consignee: "",
                address: "",
                orderBatch: "",
                status: "",
            },
            searchFormStash: {},
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            addOrderForm: {
                id: "",
                orderBatch: "",
            },
            exportOrderVisible: false,
            exportOrderForm: {
                orderBatch: "",
            },

            orderForm: {
                orderBatch: "",
            },
            reviewForm: {
                name:"",//收货人
                pass:true,
                reason: "",
                workflowId:"",
                step:"",
                orderId:"",
                totalPrice:""

            },
            selectData:[],//选中的数据
            viewDeliverVisible: false,
            rules: {
                orderBatch: [
                    { required: true, message: '请输入订单编号', trigger: 'blur' }
                ],
            },
            editDemandMonthVisible: false,
            demandMonthOption: [],
            editDemandMonthForm: {
                id: "",
                demandMonth: "",
            }
        }
    },
    methods: {
        onSearch() {
            this.loading = true;
            this.selectData = [];
            let _this = this
            let cond = {...this.searchForm};
            if(!this.searchForm.status) {
                cond['status'] = undefined;
            }
            if(this.searchForm.timeDate != "" &&this.searchForm.timeDate!=null) {
                cond["startTime"] = this.searchForm.timeDate[0];
                cond["endTime"] = this.searchForm.timeDate[1];
            }
            this.searchFormStash = {...cond};
            this.loading = true;
            this.$axios.post("/admin/rfq/searchInternalReview",{
                cond,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if( resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            }).finally(() => {
                this.loading=false;
            });
        },

        exportOrder() {
            const that = this;
            this.$refs.exportOrderForm.validate(valid => {
                if(valid) {
                    downloadByPost({
                        axios: that.$axios,
                        url: "/admin/rfq/exportCustomerOrderDetail",
                        data: that.exportOrderForm,
                        success: response => {
                            convertRes2Blob(response);
                        },
                    });
                }
            });
        },
        order() {
            const that = this;
            this.$refs.orderForm.validate(valid => {
                if(valid) {
                    this.$axios.post("/admin/order/customerOrder", this.orderForm)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {
                            that.$notify({
                                title: '成功',
                                message: '数据保存成功',
                                type: 'success'
                            });
                            that.orderVisible = false;
                            that.onSearch();
                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    });
                }
            });
        },
        passIt(orderId,step,workflowId,name,totalPrice){
            this.reviewForm.pass = 'true';
            this.reviewForm.reason = '';
            this.reviewForm.orderId = orderId;
            this.reviewForm.step = step;
            this.reviewForm.workflowId = workflowId;
            this.reviewForm.name = name;
            this.reviewForm.totalPrice = totalPrice;
            this.addProcess();
        },
        showReviewDialog(orderId,step,workflowId,name,totalPrice) {//打开审核对话框
            this.reviewForm.pass = 'false';
            this.reviewForm.reason = '';
            this.reviewForm.orderId = orderId;
            this.reviewForm.step = step;
            this.reviewForm.workflowId = workflowId;
            this.reviewForm.name = name;
            this.reviewForm.totalPrice = totalPrice;
            this.reviewVisible = true;

        },
        addProcess() {//添加审核过程
            //确定通过abc提交的总价￥123,456,78的订单吗?
            const that = this;
            let cond = {...this.reviewForm};
            let optate = "通过";
            optate = cond.pass == 'false' ? "驳回" : "通过";
            this.$confirm('确定' + optate +'【' +cond.name+'】提交的总价【￥'+cond.totalPrice+'】的订单吗？', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {

                cond.pass = cond.pass == 'true' ? true : false;
                if (cond.pass) {
                    cond.reason = '';
                }
                cond={pass:cond.pass,reason:cond.reason,orderId:cond.orderId,step:cond.step
                    ,workflowId:cond.workflowId};
                this.loading = true;
                this.$axios.post("/admin/rfq/review", cond)
                    .then(function (response) {
                        let resp = response.data;
                        if (resp.header.status == 0) {

                            that.reviewVisible = false;
                            if (resp.data == true) {//审核完毕
                                that.changeOrder(that.reviewForm.orderId);
                                that.onSearch();
                            } else {
                                that.$notify({
                                    title: '成功',
                                    message: '数据保存成功',
                                    type: 'success'
                                });
                                that.onSearch();
                            }

                        } else {
                            that.$notify.error({
                                title: '错误',
                                message: resp.header.msg
                            });
                        }
                    }).finally(() => {
                        this.loading = false;
                    });
            });
        },
        changeOrder(orderId) {//修改状态为下单
            const that = this;
            this.$axios.post("/admin/rfq/reviewOver", {orderId:orderId})
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        if(resp.data == true){//审核完毕
                            that.$notify({
                                title: '成功',
                                message: '已下单',
                                type: 'success'
                            });
                        }
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleToReviewDetail(row) {
            let showBtn = (row.status == 0&&row.review);

            this.$router.push({name: "customerReviewDetail", params: {from: "rfq", orderId: row.id,title:'订单详情',
                    step:row.reviewStep, workflowId:row.workflowId, name:row.consignee,totalPrice:row.totalPrice,showBtn:showBtn}})
        },
        handleToDeliver(row) {
            // this.viewDeliverVisible = true;
            this.$router.push({name: "deliver", params: {from: "order", orderId: row.id,title:'签收单'}});
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        judgeSelect(row){
          return (row.status != 5 && row.status != 6);// 返回true该行可选，返回false则不可选

        },
        exportOrderDialogNew(command){
            let data = {};
            switch(command) {
                case 'all': {
                    data = {cond: {...this.searchFormStash}};
                    break;
                }
                case 'selected': {
                    if (this.selectData.length == 0) {
                        this.$message({
                            type: 'error',
                            message: '请选择要导出的订单',
                            duration: 2000
                        });
                        return;
                    }
                    data = {orderIds: this.selectData.map(it => it.id)};
                    // const that = this;
                    // let arr = [];
                    // let val = this.selectData;
                    // if (val.length > 0) {
                    //     for (let i = 0; i < val.length; i++) {
                    //         arr.push(val[i].id);
                    //     }
                    // }
                    break;
                }
            }
            this.loading = true
            downloadByPost({
                axios: this.$axios,
                url: "/admin/easypoi/order",
                data,
                success: response => {
                    convertRes2Blob(response);
                },
                complete: () => {
                    this.loading = false;
                }
            });
            /*
            if(this.selectData.length == 0){
                this.$message({
                    type: 'info',
                    message: '请选择要导出的订单',
                    duration: 2000
                });
                return;
            }
            const that = this;
            let arr = [];
            let val = this.selectData;
            if(val.length>0){
                for(let i=0; i<val.length; i++){
                    arr.push(val[i].id);
                }
                this.loading = true;
                downloadByPost({
                    axios: that.$axios,
                    url: "/admin/easypoi/order",
                    data: arr,
                    success: response => {
                        convertRes2Blob(response);
                    },
                    complete: () => {
                        that.loading = false;
                    }
                });
            }
            */
        },
        exportDeliver(){
            if(this.selectData.length == 0){
                this.$message({
                    type: 'info',
                    message: '请选择要导出的订单',
                    duration: 2000
                });
                return;
            }
            const that = this;
            let arr = [];
            let val = this.selectData;
            if(val.length>0){
                for(let i=0; i<val.length; i++){
                    arr.push(val[i].id);
                }
                downloadByPost({
                    axios: that.$axios,
                    url: "/admin/easypoi/deliver",
                    data: arr,
                    success: response => {
                        convertRes2Blob(response);
                    },
                });
            }
        },
        canSelect(row) {
            return (row['status'] !== 5 && row['status'] !== 6);
        },
        handleEditDemandMonth(row) {
            this.editDemandMonthVisible = true;
            this.editDemandMonthForm = {id: row['id'], demandMonth: row['demandMonth']};
        },
        onSubmitEditDemandMonth() {
            const that = this;
            this.$axios.post("/admin/rfq/updateDemandMonth", this.editDemandMonthForm)
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '已更新需求所属月份',
                            type: 'success'
                        });
                        that.onSearch();
                        that.editDemandMonthVisible = false;
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
    },
    created() {
        this.onSearch();
        const now = new Date();
        const prevMonth = new Date();
        prevMonth.setMonth(prevMonth.getMonth() - 1);
        const nextMonth = new Date();
        nextMonth.setMonth(nextMonth.getMonth() + 1);
        this.demandMonthOption = [
            `${prevMonth.getFullYear()}年${prevMonth.getMonth()<9 ? '0'+(prevMonth.getMonth()+1) : prevMonth.getMonth()+1}月`,
            `${prevMonth.getFullYear()}年${prevMonth.getMonth()<9 ? '0'+(prevMonth.getMonth()+1) : prevMonth.getMonth()+1}月补充`,
            `${now.getFullYear()}年${now.getMonth()<9 ? '0'+(now.getMonth()+1) : now.getMonth()+1}月`,
            `${now.getFullYear()}年${now.getMonth()<9 ? '0'+(now.getMonth()+1) : now.getMonth()+1}月补充`,
            `${nextMonth.getFullYear()}年${nextMonth.getMonth()<9 ? '0'+(nextMonth.getMonth()+1) : nextMonth.getMonth()+1}月`,
            `${nextMonth.getFullYear()}年${nextMonth.getMonth()<9 ? '0'+(nextMonth.getMonth()+1) : nextMonth.getMonth()+1}月补充`,
        ];
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    },
}
</script>
